import React, {useEffect, useRef, useState} from "react";
import {Button, Divider, Grid} from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import LabelDetail from "../../components/LabelDetail";
import {useParams} from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Checkbox from "@mui/material/Checkbox";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import {ArrowRight} from "@mui/icons-material";
import {BASE_URL} from "../../constants";
import {reportErrors} from "../../helpers";
import AlertBar from "../../components/AlertBar";

export default function UserDetails(props) {
    const alert = useRef();
    const [roles, setRoles] = useState({});
    const {data: employee} = useFetch(`api/user-details/${props?.employeeId}`, null, true, {}, (response) => response.data.data);
    const [canSubmit, setCanSubmit] = useState(true);

    useEffect(() => {
        loadData();
    }, []);
    const loadData = () => {
        let url = `${BASE_URL}api/roles/${props?.employeeId}`;
        window.axios
            .get(url)
            .then((response) => {
                setRoles(response.data.data)
            })
            .catch((error) => {
                reportErrors(alert.current, error);
            });
    };

    const submit = () => {
        if (canSubmit) {
            setCanSubmit(false);
            window.axios
                .put(`${BASE_URL}api/roles/${roles?.roleId}`, {roles: roles})
                .then(response => {
                    alert.current.showSuccess("Update Successfully.");
                    setCanSubmit(true);
                })
                .catch(error => {
                    setCanSubmit(true);
                    reportErrors(alert.current, error);
                });
        }
    }

    return (
        <>
            <Box sx={{p: 1}}>
                <Grid container spacing={2} sx={{mb: 2}}>
                    <Grid item xs={11}><Typography variant="h5">User Details</Typography></Grid>
                    <Grid item xs={12}><Divider/></Grid>
                    <Grid item xs={3}><LabelDetail label="First Name" description={employee?.firstName}/></Grid>
                    <Grid item xs={3}><LabelDetail label="Middle Name" description={employee?.middleName}/></Grid>
                    <Grid item xs={3}><LabelDetail label="Last Name" description={employee?.lastName}/></Grid>
                    <Grid item xs={3}><LabelDetail label="Phone" description={employee?.phone}/></Grid>
                    <Grid item xs={3}><LabelDetail label="Email Address" description={employee?.email}/></Grid>
                    <Grid item xs={3}><LabelDetail label="Gender" description={employee?.Gender}/></Grid>
                    <Grid item xs={12}><Divider/></Grid>
                </Grid>
                <Typography variant="h5">User Access</Typography>
                <AlertBar ref={alert}/>
                <List dense sx={{width: '100%', bgcolor: 'background.paper'}}>
                    <ListItem secondaryAction={
                        <Checkbox
                            edge="end"
                            checked={roles?.canViewCustomer === "yes"}
                            onChange={(event) => setRoles({
                                ...roles,
                                canViewCustomer: event.target.checked ? "yes" : "no"
                            })}
                            inputProps={{'aria-labelledby': 1}}
                        />
                    }
                              disablePadding>
                        <ListItemButton>
                            <ArrowRight/>
                            <ListItemText id={1} primary="Can view customer list"/>
                        </ListItemButton>
                    </ListItem>
                    <ListItem secondaryAction={
                        <Checkbox
                            edge="end"
                            checked={roles?.canViewCustomerOrder === "yes"}
                            onChange={(event) => setRoles({
                                ...roles,
                                canViewCustomerOrder: event.target.checked ? "yes" : "no"
                            })}
                            inputProps={{'aria-labelledby': 2}}
                        />
                    }
                              disablePadding>
                        <ListItemButton>
                            <ArrowRight/>
                            <ListItemText id={2} primary="Can view customer orders"/>
                        </ListItemButton>
                    </ListItem>
                    <ListItem secondaryAction={
                        <Checkbox
                            edge="end"
                            checked={roles?.canAddCustomerOrder === "yes"}
                            onChange={(event) => setRoles({
                                ...roles,
                                canAddCustomerOrder: event.target.checked ? "yes" : "no"
                            })}
                            inputProps={{'aria-labelledby': 3}}
                        />
                    }
                              disablePadding>
                        <ListItemButton>
                            <ArrowRight/>
                            <ListItemText id={3} primary="Can add customer orders"/>
                        </ListItemButton>
                    </ListItem>
                    <ListItem
                        secondaryAction={
                            <Checkbox
                                edge="end"
                                checked={roles?.canUploadCustomerOrderBatches === "yes"}
                                onChange={(event) => setRoles({
                                    ...roles,
                                    canUploadCustomerOrderBatches: event.target.checked ? "yes" : "no"
                                })}
                                inputProps={{'aria-labelledby': 4}}
                            />
                        }
                        disablePadding>
                        <ListItemButton>
                            <ArrowRight/>
                            <ListItemText id={4} primary="Can upload customer order batches"/>
                        </ListItemButton>
                    </ListItem>
                    <ListItem secondaryAction={
                        <Checkbox
                            edge="end"
                            checked={roles?.canAccessCustomerBilling === "yes"}
                            onChange={(event) => setRoles({
                                ...roles,
                                canAccessCustomerBilling: event.target.checked ? "yes" : "no"
                            })}
                            inputProps={{'aria-labelledby': 5}}
                        />
                    }
                              disablePadding>
                        <ListItemButton>
                            <ArrowRight/>
                            <ListItemText id={5} primary="Can access customer billing"/>
                        </ListItemButton>
                    </ListItem>
                    <ListItem
                        secondaryAction={
                            <Checkbox
                                edge="end"
                                checked={roles?.canAccessPaymentTransaction === "yes"}
                                onChange={(event) => setRoles({
                                    ...roles,
                                    canAccessPaymentTransaction: event.target.checked ? "yes" : "no"
                                })}
                                inputProps={{'aria-labelledby': 6}}
                            />
                        }
                        disablePadding>
                        <ListItemButton>
                            <ArrowRight/>
                            <ListItemText id={6} primary="Can access payment transaction"/>
                        </ListItemButton>
                    </ListItem>
                    <ListItem secondaryAction={
                        <Checkbox
                            edge="end"
                            checked={roles?.canAccessInventory === "yes"}
                            onChange={(event) => setRoles({
                                ...roles,
                                canAccessInventory: event.target.checked ? "yes" : "no"
                            })}
                            inputProps={{'aria-labelledby': 7}}
                        />
                    }
                              disablePadding>
                        <ListItemButton>
                            <ArrowRight/>
                            <ListItemText id={7} primary="Can access inventory"/>
                        </ListItemButton>
                    </ListItem>
                    <ListItem secondaryAction={
                        <Checkbox
                            edge="end"
                            checked={roles?.canAccessUserManagement === "yes"}
                            onChange={(event) => setRoles({
                                ...roles,
                                canAccessUserManagement: event.target.checked ? "yes" : "no"
                            })}
                            inputProps={{'aria-labelledby': 8}}
                        />
                    }
                              disablePadding>
                        <ListItemButton>
                            <ArrowRight/>
                            <ListItemText id={8} primary="Can access user management"/>
                        </ListItemButton>
                    </ListItem>
                </List>
                <Grid container spacing={2} sx={{mt: 2}}>
                    <Grid item xs={11}/>
                    <Grid item xs={1}>
                        <Button
                            disableElevation sx={{textTransform: "none"}}
                            fullWidth size="medium"
                            variant="contained" color="primary"
                            onClick={() => submit()}>
                            Sumbit
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}